import { ca } from '@cian/analytics';
import { ICommonNewbuilding } from '../../types/newbuilding/newbuildings';
import { getNewbuildingInfo } from '../../utils/analytics';

export function trackNewbuildingFromTheBuilderBlockAppearance(newbuildings: ICommonNewbuilding[]) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'similar_objects',
    action: 'show_others_JK',
    label: '',
    ds: 'desktop',
    products: newbuildings.map((similarNewbuilding, position) =>
      getNewbuildingInfo(similarNewbuilding, position + 1, 'others_JK'),
    ),
    modelVersion: '1',
  });
}

export function trackTransferToNewbuildingFromTheBuilder(newbuildings: ICommonNewbuilding[], index: number) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'similar_objects',
    action: 'click_others_JK',
    label: '',
    ds: 'desktop',
    products: [getNewbuildingInfo(newbuildings[index], index + 1, 'others_JK')],
    modelVersion: '1',
  });
}
